import React from "react";
import PropTypes from "prop-types";
import ReactPaginate from "react-paginate";
import Utility from "./Utility";
import SortOptions from "./SortOptions";

class FilteredUtilities extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      offset: 0,
      data: props.utilities,
      elements: [],
      perPage: 500,
      currentlyShowingPage: 0,
    };
  }

  componentDidMount() {
    this.getUtilities();
  }

  componentDidUpdate(prevProps) {
    if(this.props.utilities !== prevProps.utilities) {
      this.getUtilities();
    }
  }

  getUtilities = () => {
    this.setState({
      data: this.props.utilities,
      pageCount: Math.ceil(this.props.utilities.length / this.state.perPage)
    }, () => this.setItemsForCurrentPage());
  }

  setItemsForCurrentPage = () => {
    const { data, offset, perPage } = this.state;
    let items = data.slice(offset, offset + perPage);
    this.setState({
      elements: items
    });
  }

  handlePageChange = page => {
    const selectedPage = page.selected;
    const offset = selectedPage * this.state.perPage;
    this.setState({
      currentlyShowingPage: selectedPage,
      offset
    }, () => this.setItemsForCurrentPage());
  }

  render() {
    const {
      currentlyShowingPage,
      data,
      pageCount,
      elements,
      offset,
      perPage,
     } = this.state;

    const { sortBy, currentSortOption, icons } = this.props;

    const totalUtilities = data.length;

    const firstItem = offset + 1;
    const lastItem = offset + elements.length;

    return (
      <div className="filtered-pagination-wrapper">
        <div className="pagination-items-wrapper">
          <div className="pagination-items">
            <span className="utilities-number">
              {totalUtilities === 0 ?
              "No utilities found"
              :
              `Showing ${firstItem}-${lastItem} of ${totalUtilities} utilities`}
            </span>
            <SortOptions sortBy={sortBy} currentSortOption={currentSortOption} />
          </div>
        </div>
        <div className="filtered-utilities-wrapper">
          <div className="filtered-utilities">
            {elements.map(utility => <Utility utility={utility} key={utility.id} icons={icons} />)}
          </div>
          {data.length > perPage &&
            <div className="pagination-wrapper">
              <div className="pagination-list">
                <ReactPaginate
                  previousLabel="Previous"
                  nextLabel="Next"
                  pageCount={pageCount}
                  onPageChange={this.handlePageChange}
                  forcePage={currentlyShowingPage}
                  containerClassName="pagination"
                  activeClassName="active"
                  pageRangeDisplayed={2}
                  marginPagesDisplayed={1}
                  breakClassName="disabled"
                />
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

FilteredUtilities.propTypes = {
  utilities: PropTypes.arrayOf(PropTypes.shape({})),
  icons: PropTypes.shape({}),
  sortBy: PropTypes.func.isRequired,
  currentSortOption: PropTypes.string.isRequired,
};

export default FilteredUtilities;
